module.exports = __webpack_public_path__ + "img/tabela.411f1448.png";